<template>
    <div class="d-inline-block">
        <button :class="classe" @click.prevent="openSelectModal">
            <slot></slot>
        </button>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';

export default {
    name: "SelectButton",
    props: {
        classe: { type:String, default:'btn btn-primary btn-sm', required:false },
    },
    methods: {
        openSelectModal() {
            EventBus.$emit('openSelectModal');
        }
    }
}
</script>
